import { type ReactNode, useState } from 'react';
import { Button } from '@/components/primitives/Button';
import { copyToClipboard } from '@/lib/clipboard';
import { HelperActionRows } from './HelperActionRows';
import { OpenInEmailAction } from './OpenInEmailAction';

export function EmailActionRows({
  body,
  logAction,
  actions,
}: {
  body: string;
  logAction: ReactNode;
  actions?: ReactNode;
}): ReactNode {
  const [copied, setCopied] = useState(false);
  const handleCopy = async (): Promise<void> => {
    try {
      await copyToClipboard(body);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <OpenInEmailAction body={body}>
      {(openAction, status) => (
        <div className="mt-3 space-y-2">
          <HelperActionRows
            testId="email-action-row"
            primary={openAction}
            secondary={logAction}
            quiet={
              <>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => void handleCopy()}
                  aria-label="Copy draft email"
                >
                  <span className="grid">
                    <span className={`col-start-1 row-start-1 ${copied ? 'invisible' : ''}`}>
                      Copy draft email
                    </span>
                    {copied && (
                      <span className="col-start-1 row-start-1" aria-hidden="true">
                        ✓ Copied
                      </span>
                    )}
                  </span>
                </Button>
                {actions}
              </>
            }
          />
          {status}
        </div>
      )}
    </OpenInEmailAction>
  );
}
